import queryString from 'query-string';
import { takeLatest, call, put, select } from 'redux-saga/effects';

import { loginWithToken } from 'modules/auth/login/data/sagas';

import authService from 'services/authService';

import { getHomePage } from 'store/app/selectors';
import { getIsLoggedIn } from 'store/session/selectors';

import history from 'utils/browserHistory';
import { getErrorMessage } from 'utils/stringUtils';

import { types, twoFactorLogin } from './actions';

export default function* root() {
  yield takeLatest(
    types.INIT_TWO_FACTOR_AUTHENTICATION,
    initTwoFactorAuthentication,
  );
}

export function* redirectIfLoggedIn(loc) {
  const isLoggedIn = yield select(getIsLoggedIn);
  if (isLoggedIn) {
    const next = queryString.parse(loc.location.search).next;
    next ? history.push(next) : history.push(yield select(getHomePage));
  }
}

function* initTwoFactorAuthentication(action) {
  const { username, password, next } = action.payload;
  yield takeLatest(
    types.LOGIN_TWO_FACTOR_REQUEST,
    twoFactorLoginRequest,
    username,
    password,
    next,
  );
}

function* twoFactorLoginRequest(username, password, next, action) {
  try {
    const { token } = action.payload;
    const nextUrl = decodeURIComponent(next || '');
    const response = yield call(authService.twoFactorLogin, {
      username,
      password,
      token,
    });
    if (response.token) {
      yield put(twoFactorLogin.success());
      yield call(loginWithToken, response.token, nextUrl);
    }
  } catch (error) {
    yield put(
      twoFactorLogin.error({ error: getErrorMessage(error, 'Unknown error') }),
    );
  }
}
